// C3 Contracting Mock Data

export const companyInfo = {
  name: "C3 Contracting",
  tagline: "Building with a Deeper Purpose",
  email: "info@c3-contracting.com",
  phone: "(980) 680-6703",
  logo: "https://customer-assets.emergentagent.com/job_c3-refresh/artifacts/2n93nwoa_Logo%20%28Medallion%20-%20Light%20-%20White%29.png",
  logoDark: "https://customer-assets.emergentagent.com/job_c3-refresh/artifacts/qafnvk6f_Logo%20%28Medallion%20-%20Dark%29.png",
  logoIcon: "https://customer-assets.emergentagent.com/job_c3-refresh/artifacts/rb1ku3rp_Logo%20%28Icon%20Only%29.png",
  jobtreadLoginUrl: "https://app.jobtread.com"
};

export const services = [
  {
    id: 1,
    title: "New Builds",
    description: "Building your dream home from the ground up is our specialty. We work closely with you to design and construct your home or other supporting structure that perfectly suits your needs, tastes, and lifestyle.",
    icon: "Home",
    image: "https://customer-assets.emergentagent.com/job_c3admin-portal/artifacts/eh4oxqgo_new%20build.jpg"
  },
  {
    id: 2,
    title: "Home Transformations",
    description: "Complete whole-home renovations that reimagine your living space from top to bottom. We specialize in transforming outdated houses into modern, functional homes that exceed your expectations.",
    icon: "Wrench",
    image: "https://customer-assets.emergentagent.com/job_c3admin-portal/artifacts/3djy0sym_exterior_upscale_068e80a6-5312-4648-9e2f-a6da0aea25f8.png"
  },
  {
    id: 3,
    title: "Additions",
    description: "Need more space? We can seamlessly extend your home with custom additions that blend perfectly with the existing structure, from expanding living areas to creating new outdoor spaces.",
    icon: "PlusSquare",
    image: "https://customer-assets.emergentagent.com/job_c3admin-portal/artifacts/fyy8jjny_addition.jpg"
  },
  {
    id: 4,
    title: "Remodeling",
    description: "Whether it's a kitchen, bathroom, or specific room remodel, we focus on creating functional, beautiful environments tailored to your lifestyle with expert craftsmanship and attention to detail.",
    icon: "Layers",
    image: "https://customer-assets.emergentagent.com/job_c3admin-portal/artifacts/imgbb7li_remodel.jpg"
  }
];

export const processSteps = [
  {
    id: 1,
    number: "01",
    title: "Consultation",
    description: "We start by listening to understand your vision, needs, and budget. Through site visits and collaborative communication, we establish a framework for determining the scope and overall project deliverables."
  },
  {
    id: 2,
    number: "02",
    title: "Budget & Proposal",
    description: "Upon completion of the consultation phase, we prepare a comprehensive proposal outlining the project budget, scope and timeline."
  },
  {
    id: 3,
    number: "03",
    title: "Design & Planning",
    description: "When our client accepts the project proposal and executes the contract, we begin the design work and start planning for construction activities to begin."
  },
  {
    id: 4,
    number: "04",
    title: "Build",
    description: "This is where the rubber meets the road. Construction begins once the design and planning stages have advanced enough to support permitting and an efficient, continuous workflow onsite."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Francis S.",
    location: "Statesville, NC",
    text: "C3 had the expertise, resources, and professionalism needed to deliver on a challenging custom conference room table. What other contractors said couldn't be done, C3 confidently took on. They contributed their design advice, but let the customer contribute to critical decisions to make the project a success."
  },
  {
    id: 2,
    name: "Dara S.",
    location: "Concord, NC",
    text: "Working with C3 Contracting was a huge blessing. Daniel and his crew are professional, knowledgeable and patient. Our renovation was made easy by their integrity, collaborative conversation and excellent work ethic. We absolutely love our new kitchen and bathroom!"
  },
  {
    id: 3,
    name: "Rhonda B.",
    location: "Charlotte, NC",
    text: "From the initial email to connect to the initial design and throughout out my major (entire 1st floor) renovation/ remodel I have been completely impressed with C3. The creativity, partnership, communications and workmanship live up to their important business mission consistently."
  },
  {
    id: 4,
    name: "Cory W.",
    location: "Davidson, NC",
    text: "Daniel and his team are top notch. We could not have been more pleased with the work we had done. Because Daniel is a licensed contractor you know the work is up to standards and codes and done properly."
  },
  {
    id: 5,
    name: "Sandy C.",
    location: "Cornelius, NC",
    text: "Excellent service and craftsmanship! Based on my expectations, C3 created custom pieces that are beautiful, functional and timeless. Always on time and kept up to date on progress. Seamless delivery and installation."
  },
  {
    id: 6,
    name: "Kim R.",
    location: "Mooresville, NC",
    text: "Every job we used C3 for went well. Very satisfied with the work they did for us. Daniel and staff are dedicated to the details. The quality of work is exceptional. Easy to work with, fair, honest and exceptionally knowledgeable in their trades."
  },
  {
    id: 7,
    name: "Kelly G.",
    location: "China Grove, NC",
    text: "This was my first experience with a kitchen remodel. I was impressed with how smoothly and efficiently the process went from the initial consultation to the finishing details! Honesty, attention to detail and patience are a few words to describe C3 Contracting."
  },
  {
    id: 8,
    name: "Julie H.",
    location: "Mooresville, NC",
    text: "Great! The quality of work, dependability, and attention to detail were exactly what I look for in a contractor and that is what I received from C3 Contracting. I would highly recommend!"
  }
];

export const galleryImages = [
  {
    id: 1,
    src: "https://c3-contracting.com/wp-content/uploads/2019/06/gallery_widget_1.jpg",
    alt: "Kitchen Renovation",
    category: "Remodeling"
  },
  {
    id: 2,
    src: "https://c3-contracting.com/wp-content/uploads/2019/06/gallery_widget_2.jpg",
    alt: "Custom Cabinetry",
    category: "Custom Cabinets"
  },
  {
    id: 3,
    src: "https://c3-contracting.com/wp-content/uploads/2019/06/gallery_widget_3.jpg",
    alt: "Home Addition",
    category: "Additions"
  },
  {
    id: 4,
    src: "https://c3-contracting.com/wp-content/uploads/2019/06/gallery_widget_4.jpg",
    alt: "New Construction",
    category: "New Builds"
  },
  {
    id: 5,
    src: "https://c3-contracting.com/wp-content/uploads/2019/06/gallery_widget_5.jpg",
    alt: "Bathroom Remodel",
    category: "Remodeling"
  },
  {
    id: 6,
    src: "https://c3-contracting.com/wp-content/uploads/2019/06/gallery_widget_6.jpg",
    alt: "Custom Woodwork",
    category: "Custom Cabinets"
  }
];

export const jobtreadFeatures = [
  {
    id: 1,
    title: "Customer Portal",
    description: "Access your dedicated project portal anytime. View documents, track progress, approve selections, and communicate directly with our team.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Real-Time Updates",
    description: "Stay informed with real-time project updates, daily logs, photos, and milestone notifications delivered straight to your portal.",
    icon: "Bell"
  },
  {
    id: 3,
    title: "Document Management",
    description: "All your contracts, invoices, change orders, and project files organized in one secure location for easy access.",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Budget Transparency",
    description: "Track your project budget in real-time. View cost breakdowns, approved change orders, and invoice history with complete transparency.",
    icon: "DollarSign"
  },
  {
    id: 5,
    title: "Selections & Approvals",
    description: "Review and approve material selections, finishes, and design choices directly through the portal with e-signature capability.",
    icon: "CheckCircle"
  },
  {
    id: 6,
    title: "Photo & Video Gallery",
    description: "Watch your project come to life with progress photos and videos uploaded daily by our crew to your personal project gallery.",
    icon: "Camera"
  }
];

export const stats = [
  { value: "75+", label: "Years Combined Experience" },
  { value: "200+", label: "Successful Projects" },
  { value: "$1M+", label: "Individual Project Capacity" },
  { value: "100%", label: "Customer Satisfaction" }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Process",
    description: "Our tailored design-build approach puts you at the center of the project. From initial concepts to the final touches, we ensure that your home reflects your lifestyle and needs. Our team collaborates with you to design, visualize, and deliver your project seamlessly."
  },
  {
    id: 2,
    title: "Communication",
    description: "We believe in clear communication at every stage. Using the latest project management tools and 3D modeling software, we provide full transparency, ensuring you're informed and confident about each decision."
  },
  {
    id: 3,
    title: "Expertise",
    description: "With years of experience in both residential and commercial construction, our founder has honed a unique approach to problem-solving and craftsmanship. From challenging site logistics to complex structural changes, we have the expertise to deliver stunning results every time."
  }
];

export const serviceAreas = [
  'Charlotte, NC',
  'Concord, NC',
  'Kannapolis, NC',
  'Davidson, NC',
  'Cornelius, NC',
  'Mooresville, NC',
  'Lake Norman, NC',
  'China Grove, NC'
];
